import Swal from 'sweetalert2';

const DEFAULT_HEARING_URL = 'https://secapp.taxes.gov.il/em-hkz-hsb-intr';

function isRtl(lang: string): boolean {
  return lang === 'ar' || lang === 'he';
}

function yesNoLabels(lang: string): { yes: string; no: string } {
  if (lang === 'ar') {
    return { yes: 'نعم', no: 'لا' };
  }
  if (lang === 'he') {
    return { yes: 'כן', no: 'לא' };
  }
  return { yes: 'Yes', no: 'No' };
}

/** Popup 1 — confirm before sending the hearing request API. */
export function confirmHearingRequestSwal(curentLang: string): Promise<boolean> {
  const rtl = isRtl(curentLang);
  const { yes, no } = yesNoLabels(curentLang);

  const text =
    curentLang === 'ar'
      ? 'هل أنت متأكد أنك تريد طلب جلسة استماع؟'
      : curentLang === 'he'
        ? 'האם אתה בטוח שברצונך לבקש שימוע?'
        : 'Are you sure you want to request a hearing session?';

  return Swal.fire({
    title: '',
    text,
    icon: 'question',
    showCancelButton: true,
    confirmButtonText: yes,
    cancelButtonText: no,
    confirmButtonColor: '#E62E2D',
    cancelButtonColor: '#64748b',
    reverseButtons: rtl,
    focusCancel: false,
    customClass: {
      popup: `swal-hearing-step${rtl ? ' swal-hearing-step--rtl' : ''}`,
    },
  }).then((result) => result.isConfirmed);
}

/** Popup 2 — after successful API: optional redirect to tax authority portal (new tab). */
export function promptGoToTaxPortalSwal(
  curentLang: string,
  hearingUrl?: string,
): Promise<void> {
  const rtl = isRtl(curentLang);
  const { yes, no } = yesNoLabels(curentLang);
  const url = hearingUrl?.trim() || DEFAULT_HEARING_URL;

  const text =
    curentLang === 'ar'
      ? 'تم تحديد جلسة استماع. هل تريد الانتقال لموقع الضريبة لتحديد تاريخ الجلسة؟'
      : curentLang === 'he'
        ? 'בקשת השימוע נשלחה בהצלחה. האם ברצונך לעבור לאיזור האישי לקביעת מועד לפגישה?'
        : 'Hearing request sent successfully. Do you want to go to the tax authority website to schedule the session?';

  return Swal.fire({
    title: '',
    text,
    icon: 'success',
    showCancelButton: true,
    confirmButtonText: yes,
    cancelButtonText: no,
    confirmButtonColor: '#28a745',
    cancelButtonColor: '#64748b',
    reverseButtons: rtl,
    focusCancel: false,
    customClass: {
      popup: `swal-hearing-step${rtl ? ' swal-hearing-step--rtl' : ''}`,
    },
  }).then((result) => {
    if (result.isConfirmed && url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  });
}
